var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.activityImage && _vm.activityImage.length>1)?_c('Wp_image',{attrs:{"url":_vm.activityImage,"radius":5}}):_vm._e(),_c('div',{staticClass:"cell_title"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.linkContent)}})])],1)}
var staticRenderFns = []

export { render, staticRenderFns }